import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import { Container, Message, Button, Image, Segment, Icon } from 'semantic-ui-react';
import CookieIcon from '../images/cookie.png';
import './CookiePopup.css';

const cookies = new Cookies();

export default class CookiesPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.cookie = 'rafalradomski-com-user-has-accepted-cookies';
        this.cookieExpiration = { years: 1 };
        this.cookiePath = '';
    }

    getSecondsSinceExpiration = cookieExpiration => {
        if (typeof cookieExpiration === 'number') {
            return cookieExpiration;
        }

        const SECONDS_IN_YEAR = 31536000,
            SECONDS_IN_DAY = 86400,
            SECONDS_IN_HOUR = 3600;

        const _cookieExpiration = {
            years: 0,
            days: 0,
            hours: 0,
            ...cookieExpiration,
        };

        const { years, days, hours } = _cookieExpiration;

        return years * SECONDS_IN_YEAR + days * SECONDS_IN_DAY + hours * SECONDS_IN_HOUR;
    };

    render() {
        return cookies.get(this.cookie) ? (
            ''
        ) : (
            <Segment inverted style={{ marginBottom: 0, backgroundColor: '#d4d4d5' }} id="cookiepopup">
                <Container textAlign="center">
                    <Message floating>
                        <div
                            style={{
                                margin: 'auto',
                            }}
                        >
                            <Image
                                src={CookieIcon}
                                style={{
                                    width: '32px',
                                    height: '32px',
                                    display: 'inline-block',
                                    verticalAlign: 'middle',
                                    marginRight: '10px',
                                }}
                            />
                            <span style={{ verticalAlign: 'middle' }}>
                                <span style={{ marginRight: '10px' }}>
                                    By continuing to use the site, you agree to the use of cookies.
                                </span>
                                <a
                                    href="https://www.iubenda.com/privacy-policy/82517659"
                                    className="iubenda-white iubenda-embed "
                                    title="Privacy Policy"
                                >
                                    More information
                                </a>{' '}
                                <Button
                                    size="mini"
                                    color="green"
                                    icon
                                    onClick={() => {
                                        cookies.set(this.cookie, true, {
                                            path: this.cookiePath,
                                            expires: new Date(
                                                Date.now() +
                                                    this.getSecondsSinceExpiration(this.cookieExpiration) * 1000
                                            ),
                                        });
                                        this.setState({
                                            accepted: true,
                                        });
                                    }}
                                >
                                    <Icon name="cancel" /> Accept
                                </Button>
                            </span>
                        </div>
                    </Message>
                </Container>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CookiePopup.js